import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Nav, Dropdown } from "react-bootstrap"
import "./Header.css";
import "../../assets/css/Hero.css";
import img1 from "../../assets/images/twitter.png";
import img2 from "../../assets/images/insta.png";
import img3 from "../../assets/images/facebook.png";
import img4 from "../../assets/images/linkedin.png";
import img5 from "../../assets/images/searchicon.png";
import img6 from "../../assets/images/Glyph Home png.png";
import logoimg from "../../assets/images/Final_Logo.png";
import glyphlogo from "../../assets/images/logo glyph.png";
import axios from "axios";
import { toast } from 'react-toastify';


const Header = () => {
    const [services, setServices] = useState([]);
    const [socials, setSocials] = useState([])
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const [searchQuery, setSearchQuery] = useState("");
    const [scrolled, setScrolled] = useState(false);
    const navigate = useNavigate();


    const styles = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        fontSize: "3rem"
    }

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const fetchData = async () => {
        const abortController = new AbortController();

        try {

            const [serviceResponse, socialResponse] = await Promise.all([
                axios.get("https://api.glyphqai.com/api/get-servicetype", { signal: abortController.signal }),
                axios.get("https://api.glyphqai.com/api/get-all-links", { signal: abortController.signal })
            ]);

            setServices(serviceResponse.data.service_type);
            setSocials(socialResponse.data.socialLinks);
            toast.success("Services Fetched Successfully");
        } catch (err) {
            if (!abortController.signal.aborted) {
                console.error("Failed to fetch Services:", err);
                toast.error("Failed to fetch Services. Please try again later.");
            }
        }
        return () => {
            abortController.abort();
        };
    };
    useEffect(() => {
        fetchData();
    }, []);

    const handleServiceClick = (service) => {
        navigate(`/Service/${service.id}`, {
            state: { service: service }
        });
        toggleNav();
    };

    const toggleNav = () => {
        setIsMenuOpen(prev => !prev)
    };

    const filteredServices = services.filter((service) =>
        service.title.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const handleNavigate = (path) => {
        toggleNav();
        navigate(path);
    }

    const limitedSuggestions = filteredServices.slice(0, 3);

    const handleKeyPress = (event) => {
        if (event.key === "Enter" && limitedSuggestions.length > 0) {
            const firstService = limitedSuggestions[0];
            navigate(`/Service?id=${firstService.id}`);
        }
    };

    return (
        <>
            {/* Header Section */}
            <div className={`header ${scrolled ? "scrolled" : ""}`}>


                <header
                    id="header"
                    className="header z-100 w-100 d-flex justify-content-between align-items-center position-fixed top-0 start-0  "
                    style={{ zIndex: 10000, backgroundColor: "transparent" }}
                >
                    {/* Left Content */}
                    <div className=" d-lg-none d-block justify-content-between align-items-center h-100">
                        <Link to="/" className="text-white text-decoration-none small">
                            <img
                                src={logoimg}
                                alt="Twitter"
                                height="30px"
                                id="logo"
                                style={{ marginTop: "5px" }}
                                className="img-hover"
                            />
                        </Link>
                    </div>
                    <div className="test-btn left_content d-lg-flex d-none mt-1 justify-content-between gap-2 align-items-center h-100" style={{ marginLeft: "40px" }}>
                        <Link
                            to={socials?.find(social => social.type == "twitter_url")?.value || "#"}
                            className="text-white text-decoration-none small "
                        >
                            <img
                                src={img1}
                                alt="Twitter"
                                height="30px"
                                id="twitter"
                                style={{ marginTop: "5px" }}
                                className="img-hover"
                            />
                        </Link>
                        <Link
                            to={socials?.find(social => social.type == "instagram_url")?.value || "#"}
                            className="text-white text-decoration-none ms-3"
                        >
                            <img
                                src={img2}
                                alt="Instagram"
                                height="30px"
                                id="instagram"
                                style={{ marginTop: "4px" }}
                                className="img-hover"
                            />
                        </Link>
                        <Link
                            to={socials?.find(social => social.type == "facebook_url")?.value || "#"}
                            className="text-white text-decoration-none small ms-3 mt-1"
                        >
                            <img
                                src={img3}
                                alt="Facebook"
                                id="facebook"
                                height="30px"
                                className="img-hover"
                            />
                        </Link>
                        <Link
                            to={socials?.find(social => social.type == "linkedin_url")?.value || "#"}
                            className="text-white text-decoration-none small mx-4 mt-1"
                        >
                            <img
                                src={img4}
                                alt="LinkedIn"
                                height="25px"
                                id="linkedin"
                                className="img-hover"
                            />
                        </Link>
                        <Link
                            to="mailto:glyphus1@gmail.com"
                            className="text-white text-decoration-none email ms-1 mt-1"
                        >
                            {socials?.find(social => social.type == "gmail_url")?.value || "glyph@gmail.com"}
                        </Link>
                    </div>
                    <div className="home-redirect">
                        <Link
                            className="text-white text-decoration-none "
                            to="/"
                        >
                            <img
                                src={img6}
                                alt="LinkedIn"
                                height="40px"
                                className="d-none d-lg-block"
                            />
                        </Link>
                    </div>

                    {/* Right Content */}
                    <div className="right_content d-flex h-100 justify-content-between align-items-center gap-2">
                        <label htmlFor="search-bar">
                            <img
                                className="mt-2"
                                id="search-icon"
                                src={img5}
                                alt="Search"
                                style={{ height: "30px", marginRight: "7px" }}
                            />
                        </label>
                        <div className="input__group  position-relative">
                            <input
                                type="text"
                                name="search-bar"
                                id="search-bar"
                                placeholder="Search here..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                onKeyDown={handleKeyPress} // Add event listener for key press
                            />
                            <div
                                id="suggestions"
                                className="suggestions w-100 position-absolute"
                            >
                                <ul className="list-group  custom-suggestions">
                                    {limitedSuggestions.map((service) => (
                                        <li
                                            className="list-group-item bg-dark text-white"
                                            key={service.id}
                                        >
                                            {service.title}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <p id="about_glyph" className=" about_glyph bg-transparent">
                            <Link to="/About" className="text-decoration-none about_glyph_text">
                                ABOUT GLYPH
                            </Link>
                        </p>
                        <img
                            onClick={toggleNav}
                            className="glyph_logo"
                            src={glyphlogo}
                            alt="Search"
                            style={{
                                cursor: "pointer",
                                height: "50px",
                                width: "50px",
                                rotate: "2deg",
                                marginRight: "25px",
                                marginTop: "15px",
                                objectFit: "cover",
                            }}
                        />
                    </div>
                </header>

                {/* Hero Navigation */}
                <div
                    className={`offcanvas offcanvas-start ${isMenuOpen ? "show" : ""}`}
                    tabIndex="-1"
                    style={{ backgroundColor: "black", width: "100%" }}
                >
                    <div className="offcanvas-body" style={styles}>
                        <Nav className="flex-column">
                            <Nav.Link onClick={() => handleNavigate("/")} className="text-white">Home</Nav.Link>
                            <Nav.Link onClick={() => handleNavigate("/About")} className="text-white">About</Nav.Link>

                            <Dropdown>
                                <Dropdown.Toggle variant="dark" id="services-dropdown" className="p-4 d-flex align-items-center mx-auto py-5 bg-black text-capitalize" style={{ fontSize: "2.9rem" }}>
                                    Services
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="bg-dark" style={{ left: "60%", translate: "0% -5%" }}>
                                    {services.map(service => (
                                        <Dropdown.Item
                                            key={service.id}
                                            className="text-white"
                                            onClick={() => handleServiceClick(service)}
                                        >
                                            {service.title}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>

                            <Nav.Link onClick={() => handleNavigate("/Testimonial")} className="text-white">Testimonial</Nav.Link>
                            <Nav.Link onClick={() => handleNavigate("/Portfolio")} className="text-white">Portfolio</Nav.Link>
                        </Nav>
                    </div>
                </div>
            </div >
        </>
    );
};

export default Header;
